export enum UserStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  INVITED = 'Invited'
}

export enum UserRole {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  MANAGER = 'manager',
  USER = 'user'
}

export interface User {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  organization_id: number;
  role_id: number;
  status: UserStatus;
  email_verified: boolean;
  oauth_provider?: string;
  oauth_provider_id?: string;
}

export interface Role {
  id: number;
  name: string;
  description?: string;
}

export interface LoginRequest {
  username: string; // email
  password: string;
}

export interface LoginResponse {
  access_token: string;
  token_type: string;
  // user info is embedded in the JWT payload (user_info dict)
}

export interface RegisterRequest {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  organization_id: number;
  role_id: number;
}

export interface UserUpdate {
  email?: string;
  first_name?: string;
  last_name?: string;
  role_id?: number;
  status?: string;
}

export interface AuthContextType {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
  refreshUser: () => Promise<void>;
}
